export interface VariableLocalizations {
    externalOptionsetDialogTitle?: string | null;
    externalOptionsetDialogPickButtonLabel?: string | null;
}
